import { useEffect } from 'react';

import { useJobProspectsStatsActions } from './JobProspectsStatsContext';
import { getJobDescriptionsStats } from './restApi';

const JobDescriptionsStatsLoader = () => {
  const { initializeState, onResponse, onError } = useJobProspectsStatsActions();

  useEffect(() => {
    initializeState();
  }, []);

  useEffect(() => {
    getJobDescriptionsStats({ onResponse, onError });
  }, []);

  return null;
};

export default JobDescriptionsStatsLoader;
